import { useTranslation } from 'react-i18next';
import { LegalPageLayout } from './LegalPageLayout';

function Section({ heading, body }: { heading: string; body: string }) {
  return (
    <section className="mb-8">
      <h2 className="text-[20px] font-semibold text-[#E2EDE7] mb-3">{heading}</h2>
      <p className="whitespace-pre-line text-[15px] leading-[1.7] text-[#788A82]">
        {body}
      </p>
    </section>
  );
}

const SECTION_KEYS = [
  'intro',
  'controller',
  'dataCategories',
  'legalBasis',
  'retention',
  'subprocessors',
  'rights',
  'cookies',
  'contact',
  'updated',
] as const;

export default function DatenschutzPage() {
  const { t } = useTranslation('legal');

  return (
    <LegalPageLayout title={t('datenschutz.title')}>
      {SECTION_KEYS.map((key) => (
        <Section
          key={key}
          heading={t(`datenschutz.${key}Heading`)}
          body={t(`datenschutz.${key}`)}
        />
      ))}
    </LegalPageLayout>
  );
}
